module.exports = __webpack_public_path__ + "static/media/whatsapp.9fcc271c.png";